import React from 'react';
import { ResourcesMegaMenuContent } from './ResourcesMegaMenu.styles';
import { ExpandableMenuProps } from 'src/molecules/Shared/2023_Q4/Header/Header.links';
import MegaMenu from 'src/molecules/Shared/2025_Q1/Header/ExpandableLinkMenu/MegaMenuContainer/MegaMenuContainer';
import ResourcesMegaMenuLinks from 'src/molecules/Shared/2025_Q1/Header/ExpandableLinkMenu/ResourcesMegaMenu/ResourcesMegaMenuLinks';
import ResourcesMegaMenuFeatured from 'src/molecules/Shared/2025_Q1/Header/ExpandableLinkMenu/ResourcesMegaMenu/ResourcesMegaMenuFeatured';

const ResourcesMegaMenu = ({ isOpen, onClose }: ExpandableMenuProps): JSX.Element => (
  <MegaMenu
    isOpen={isOpen}
    onClose={onClose}
  >
    <ResourcesMegaMenuContent>
      <ResourcesMegaMenuLinks />
      <ResourcesMegaMenuFeatured />
    </ResourcesMegaMenuContent>
  </MegaMenu>
);

export default ResourcesMegaMenu;
